import useMachineStore from "../../Store/MachineStore";
import React from "react";
import IconButton from "@mui/material/IconButton";
import {Laptop, MoreVert, Print} from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {ListItemIcon, ListItemText} from "@mui/material";
import Utils from "../../Utils/Utils";
import Tooltip from "@mui/material/Tooltip";

export default function SendTaskButton({machine, onSendTask}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [targetMachines, setTargetMachines] = React.useState([]);
    const openMenu = Boolean(anchorEl);
    const handleOpenMenu = (event) => {
        event.preventDefault()
        event.stopPropagation()
        // Lu à l'ouverture seulement : abonné au store, chacun des centaines de boutons ⋮ se re-rendait à chaque événement socket.
        const {machines} = useMachineStore.getState()
        setTargetMachines(machines.filter(m => m.power && (!machine || machine.id !== m.id)))
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                size={"small"}
                sx={{minWidth: 28}}
                aria-controls={openMenu ? 'long-menu' : undefined}
                aria-expanded={openMenu ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleOpenMenu}
            >
                <MoreVert fontSize="small"/>
            </IconButton>

            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
            >
                {targetMachines.map(_machine => (
                    <MenuItem sx={{pointerEvents: "none"}} key={_machine.id}>
                        <ListItemIcon sx={{pointerEvents: "all"}} onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                        }}>
                            <Laptop fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText sx={{pointerEvents: "all"}} onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                        }}>{Utils.formatMachineName(_machine)}</ListItemText>
                        <ListItemIcon sx={{position: "relative", ml: 2}}>
                            <Tooltip title="Imprimer en priorité">
                                <>
                                    <span style={{
                                        position: "absolute",
                                        left: 13.75,
                                        top: 1,
                                        width: 7,
                                        height: 7,
                                        borderRadius: "50%",
                                        background: "green"
                                    }}></span>
                                    <IconButton
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            onSendTask(_machine, "first")
                                            handleClose(e)
                                        }}
                                        sx={{pointerEvents: "all"}} size="small">
                                        <Print/>
                                    </IconButton>
                                </>
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemIcon sx={{position: "relative"}}>
                            <Tooltip title="Imprimer à la fin">
                                <>
                                    <span style={{
                                        position: "absolute",
                                        left: 13.75,
                                        bottom: 1,
                                        width: 7,
                                        height: 7,
                                        borderRadius: "50%",
                                        background: "red"
                                    }}></span>
                                    <IconButton
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            onSendTask(_machine, "last")
                                            handleClose(e)
                                        }}
                                        sx={{pointerEvents: "all"}} size="small">
                                        <Print/>
                                    </IconButton>
                                </>
                            </Tooltip>
                        </ListItemIcon>
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}
